import styled from 'styled-components';

export const NotesWrapSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
  background-color: ${({ theme }) => theme.color.surface.background};
  justify-content: flex-start;
`;

export const NotesSC = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.surface.baseline};
  position: relative;
  display: flex;
`;

export const LeftDotsSC = styled.div`
  width: auto;
  height: 100%;
  padding: 36px 15px 5px 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.color.surface.baseline};
  .dots {
    width: 1px;
    height: 100%;
    margin-top: 8px;
    margin-right: -2px;
    border-left: 2px dashed ${({ theme }) => theme.color.border.outline};
  }
`;

export const NotesListSC = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.surface.baseline};

  .loader {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .notes-list-wrap {
    position: relative;
  }
`;
